import React, { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isArray } from 'lodash';
import classnames from 'classnames';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { Tooltip, Radio, Button, Typography } from 'antd';

import * as actionsGridView from 'common/components/grid-view/controllers/actions';

import { useFilterGrid } from 'hooks/useFilterGrid';
import { APL_KEY, useGetAPLGrid } from 'hooks/apl/useGetAPLGrid';

import { pathnameProductForMember } from 'pages/home/utils';

const SearchFilterRadio = () => {
  const dispatch = useDispatch();
  const pathname = window.location.pathname;

  const [enabledAplQuery, setEnabledAplQuery] = useState(false);
  const [value, setValue] = useState(-2);

  const { gridFilters, updateGridFilter } = useFilterGrid({
    entityType:
      pathname === pathnameProductForMember ? 'memberProduct' : 'product',
  });

  const { data, isLoading: loadingApl } = useGetAPLGrid({
    key: APL_KEY.getAplGrid(),
    params: {
      pageSize: 10,
      pageIndex: 1,
      sort: [{ fieldName: 'id', isAscending: false }],
    },
    enabled: enabledAplQuery,
  });

  const filterProductApl = useMemo(() => {
    if (isArray(gridFilters)) {
      return gridFilters.find((val) => val?.filter === 'apl');
    }
    return false;
  }, [gridFilters]);

  const hasMasterApl = useMemo(() => {
    if (isArray(data?.gridData)) {
      return data?.gridData.find(
        (val) => val?.aplName?.toLowerCase() === 'master apl'
      );
    }
    return false;
  }, [data]);

  const onChange = (e) => {
    setValue(e.target.value);
    dispatch(actionsGridView.resetPageCurrent());

    if (e.target.value === -2) {
      updateGridFilter(gridFilters.filter((val) => val !== filterProductApl));
    } else {
      let newFilterProducts = [...gridFilters];
      newFilterProducts = newFilterProducts.filter(
        (val) => val?.filter !== 'apl'
      );

      newFilterProducts.push({
        filter: 'apl',
        value: hasMasterApl,
      });
      updateGridFilter(newFilterProducts);
    }
  };

  const handleRemoveFilterAPL = () => {
    dispatch(actionsGridView.resetPageCurrent());

    updateGridFilter(gridFilters.filter((val) => val !== filterProductApl));
    setValue(-2);
  };

  useEffect(() => {
    const delayAplQuery = setTimeout(() => {
      setEnabledAplQuery(true);
    }, 5000);

    return () => {
      clearTimeout(delayAplQuery);
    };
  }, []);

  useEffect(() => {
    if (!filterProductApl) {
      setValue(-2);
    } else if (filterProductApl?.value?.id === hasMasterApl?.id) {
      setValue(hasMasterApl?.id);
    }
  }, [filterProductApl, hasMasterApl]);

  return (
    <div className='search-filter' style={{ paddingLeft: 4 }}>
      {filterProductApl?.value?.id === hasMasterApl?.id || !filterProductApl ? (
        <Radio.Group onChange={onChange} value={value}>
          <Radio
            className={classnames(loadingApl ? 'search__loading-apl' : null)}
            value={hasMasterApl?.id}
            disabled={!hasMasterApl}
          >
            {loadingApl ? (
              <>
                <LoadingOutlined /> Loading APL
              </>
            ) : (
              'Master APL'
            )}
          </Radio>
          <Radio value={-2}>All Products</Radio>
        </Radio.Group>
      ) : (
        <Tooltip
          title={`Remove filter APL ${filterProductApl?.value?.aplName}`}
        >
          <Button icon={<CloseOutlined />} onClick={handleRemoveFilterAPL}>
            <Typography.Text ellipsis={true} style={{ maxWidth: 500 }}>
              You are viewing product data from APL{' '}
              {filterProductApl?.value?.aplName}
            </Typography.Text>
          </Button>
        </Tooltip>
      )}
    </div>
  );
};

export default SearchFilterRadio;
